module.exports = __webpack_public_path__ + "static/logo-3b064d972e4d26ca8139734f4babcd1e.svg";